/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useRef, useState } from "react";
import { getCustomToken } from "../helpers/utils";
import { toast } from "react-toastify";
import { ToastContext } from "../hooks/ToastContext";
import RewardService from "../services/Reward.Service";
import { FailedNotification } from "../components/Notifications";

function ItemSelectReward(props) {
  const { handleToastState } = useContext(ToastContext);

  const showToast = () => {
    handleToastState(true); // Set toast as active
    // Logic to display the toast
  };

  const dismissToast = () => {
    handleToastState(false); // Set toast as inactive
    // Logic to dismiss the toast
  };

  const [showSuggestions, setShowSuggestions] = useState(false); // State to control suggestion visibility
  const [error, setError] = useState(null);

  const [searchText, setSearchText] = useState("");
  const [debouncedValue, setDebouncedValue] = useState("");

  useEffect(() => {
    fetchSuggestions(debouncedValue); // Fetch initial suggestions on component mount

    // eslint-disable-next-line
  }, [debouncedValue]);

  const handleChange = (event) => {
    setSearchText(event.target.value);
    setError(null);

    if (event.target.value.length > 1) {
      setShowSuggestions(true);
    }
  };

  /* eslint-disable no-unused-vars */
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedValue(searchText);
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [searchText]);

  const fetchSuggestions = async (search) => {
    try {
      let apiUrl = `${process.env.REACT_APP_BACKEND_URL}/rewards?page=1&size=10&published=true`;

      // Check if 'search' is not empty
      if (search !== "") {
        apiUrl += `&search=${search}`;
      }

      const response = await fetch(apiUrl, {
        headers: {
          Authorization: `Bearer ${getCustomToken()}`,
        },
      }); // Replace with your actual API endpoint
      const data = await response.json();
      props.setRewardData(data.items || []); // Assuming the API response has a "suggestions" property
    } catch (error) {
      console.error("Error fetching suggestions:", error);
    }
  };

  useEffect(() => {
    if (!props.activeReward.title) {
      setSearchText("");
    } else {
      setSearchText(props.activeReward.title);
    }
  }, [props.activeReward]);

  return (
    <div>
      <input
        className={"form-control"}
        value={searchText}
        placeholder="Search reward by title.."
        onChange={handleChange}
        onFocus={() => {
          setShowSuggestions(true);
        }}
      />
      {showSuggestions && (
        <div className="suggestions">
          {props.rewardData.map((reward) => (
            <div
              className="suggestion"
              key={reward.id}
              onClick={async () => {
                await RewardService.getReward(reward.id)
                  .then((response) => {
                    props.setActiveReward(response.data);
                    if (response.data.bonus_points === 0) {
                      props.setHasParticipationPoints(true);
                    }
                    setShowSuggestions(false);

                    dismissToast();
                  })
                  .catch((error) => {
                    if (error.response) {
                      // The request was made and the server responded with a status code >= 400
                      console.error("Error:", error.response.data);
                      console.error("Status Code:", error.response.status);

                      if (error.response.status === 422) {
                        FailedNotification(
                          error.response.data.detail[0]["msg"],
                          showToast,
                          dismissToast
                        );
                      } else {
                        FailedNotification(
                          error.response.data.detail,
                          showToast,
                          dismissToast
                        );
                      }
                    } else if (error.request) {
                      console.error("No response received:", error.request);
                    } else {
                      console.error("Error:", error.message);
                    }
                  });
              }}
            >
              {reward.title}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default ItemSelectReward;
